var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.subscription !== null)?_c('div',{staticClass:"modal-mask"},[_c('revocation-defense',{attrs:{"voucher-data":_vm.subscription,"close":_vm.clickClose,"user-service-id":_vm.subscription.userserviceid,"end-date":_vm.subscription.enddate,"is-unsubscribe":_vm.isUnsubscribe}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }